// 常量

// 房间类型
export enum ROOM_TYPE {
  AUDIO_LIVE = 5, // 音频直播
  VIDEO_LIVE = 9, // 视频直播
  VIDEO_CALL = 10 // 视频通话
}

// 性别
export enum GENDER_TYPE {
  MALE = 1,
  FEMALE = 2
}

/**
 * 消息类型
 */
export enum ROOM_CHAT_TYPE {
  CHAT_TEXT = 1, // 会话文本
  ENTER_ROOM = 2, // 成员进房
  PROMPT_TEXT = 3, // 纯文本提示消息
  GAME = 4, // 游戏消息
  CHAT_GIFT = 5, // 会话礼物
  EMOJI_RESULT = 6, // 表情结果消息
  ROOM_UPDATE = 7 // 房间更新通知
}

/**
 * 红包类型
 */
export enum ROOM_LUCKY_BAG_TYPE {
  ROOM = 'ROOM', // 房间
  ALL = 'ALL' // 全服
}

/**
 * 房间PK结果
 */
export enum ROOM_PK_RESULT {
  DRAW = 0, // 平局
  WIN = 1, // 胜利
  LOSE = 2, // 失败
  CANCEL = 3 // 未知原因结束
}

/**
 * 直播PK，对面主播的麦位索引（2号麦位）
 */
const ROOM_PK_MIC_INDEX = 1

export default {
  ROOM_TYPE,
  GENDER_TYPE,
  ROOM_CHAT_TYPE,
  ROOM_LUCKY_BAG_TYPE,
  ROOM_PK_RESULT,
  ROOM_PK_MIC_INDEX
}
